// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-5186eba6] {\n  color: gray;\n  font-weight: 300;\n}\n.image-preview[data-v-5186eba6] {\n  padding: 12px;\n  min-height: 200px;\n  background-color: #eaeaea;\n}\n.image-preview[data-v-5186eba6],\ninput[type=file][data-v-5186eba6] {\n  max-width: 620px;\n}\n.form-control-label[data-v-5186eba6] {\n  padding: 0px;\n}\n.form-control-label h4[data-v-5186eba6] {\n  margin-bottom: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
